import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Environment } from '../../environments/environment.type';

@Injectable({ providedIn: 'root' })
export class AppconfigService {
    readonly config: Environment = environment;
}
